import { StandardEvents } from '@shopify/events';

/**
 * Halven House site-wide behaviours: rotating announcement, mobile menu, cart counter.
 * Loaded by the hh-announcement and hh-header sections.
 */

/** Rotating announcement messages (one every 3.5 s). */
class HhRotator extends HTMLElement {
  /** @type {number | undefined} */
  #timer;

  connectedCallback() {
    const count = this.children.length;
    if (count < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const step = Number(this.dataset.step || 18);
    let i = 0;
    this.#timer = window.setInterval(() => {
      i = (i + 1) % count;
      this.style.transform = `translateY(-${i * step}px)`;
    }, 3500);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }
}
if (!customElements.get('hh-rotator')) customElements.define('hh-rotator', HhRotator);

if (!(/** @type {any} */ (window).hhUiReady)) {
  /** @type {any} */ (window).hhUiReady = true;

  document.addEventListener('click', (event) => {
    const burger = /** @type {HTMLElement} */ (event.target).closest?.('[data-burger]');
    if (!burger) return;
    const menu = document.querySelector('[data-menu]');
    if (!(menu instanceof HTMLElement)) return;
    menu.hidden = !menu.hidden;
    burger.setAttribute('aria-expanded', String(!menu.hidden));
  });

  /** Header dropdowns (Women / Men): click toggles, outside click or Escape closes. */
  const closeAll = (/** @type {Element | null} */ except = null) => {
    for (const dd of document.querySelectorAll('[data-dd].open')) {
      if (dd === except) continue;
      dd.classList.remove('open');
      dd.querySelector('[data-dd-t]')?.setAttribute('aria-expanded', 'false');
    }
  };
  document.addEventListener('click', (event) => {
    const t = /** @type {HTMLElement} */ (event.target);
    const trigger = t.closest?.('[data-dd-t]');
    if (trigger) {
      const dd = trigger.closest('[data-dd]');
      if (!dd) return;
      closeAll(dd);
      const open = dd.classList.toggle('open');
      trigger.setAttribute('aria-expanded', String(open));
      return;
    }
    if (!t.closest?.('[data-dd-p]')) closeAll();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });

  /** Refresh every cart counter after any cart change. */
  const refreshCount = async () => {
    const cart = await fetch(`${Theme.routes.cart_url}.js`, { cache: 'no-store' }).then((r) => r.json());
    for (const el of document.querySelectorAll('[data-hh-cart-count]')) el.textContent = String(cart.item_count);
  };
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    const { promise } = /** @type {any} */ (event);
    (promise ?? Promise.resolve()).then(refreshCount, refreshCount);
  });
}
